import { CONFIGURATION_TAB } from "../../framework/tab/tabUtilsConstants";
import configIcons from "../../assets/images/configuration/index.js";
import Shortcut from "../../framework/Shortcut";

export const initital_state_configuration = {
  label: "Configuration",
  type: CONFIGURATION_TAB,
  activeConfigTab: {
    id: 0,
    label: "Account",
  },
  configData: {},
  allowMultipleTabs: false,
  disableSwitch: true,
};

const {
  accountBlackIcon,
  settingsBlackIcon,
  undoBlackIcon,
  shoppingBlackIcon,
  purchaseBlackIcon,
  accountWhiteIcon,
  settingsWhiteIcon,
  undoWhiteIcon,
  shoppingWhiteIcon,
  purchaseWhiteIcon,
  emailBlackIcon,
  integrationConfigBlack,
  integrationConfigWhite,
  emailWhiteIcon,
} = configIcons;

export const config_menu = [
  // { label: "Home", blackIcon: homeWhiteIcon, whiteIcon: homeWhiteIcon },
  {
    id: 0,
    label: (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          height: "100%",
          padding: "0 5px",
        }}
      >
        <span>Account</span>
        <Shortcut keys={["Alt", "1"]} />
      </div>
    ),
    blackIcon: accountBlackIcon,
    whiteIcon: accountWhiteIcon,
  },
  {
    id: 1,
    label: (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          height: "100%",
          padding: "0 5px",
        }}
      >
        <span>Sales</span>
        <Shortcut keys={["Alt", "2"]} />
      </div>
    ),
    blackIcon: purchaseBlackIcon,
    whiteIcon: purchaseWhiteIcon,
  },
  // { label: "Sales",blackIcon: homeBlackIcon,whiteIcon:homeBlackIcon ,component:'sales', component:<SalesConfigPanel/>},
  {
    id: 2,
    label: (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          height: "100%",
          padding: "0 5px",
        }}
      >
        <span>Purchase</span>
        <Shortcut keys={["Alt", "3"]} />
      </div>
    ),
    blackIcon: shoppingBlackIcon,
    whiteIcon: shoppingWhiteIcon,
  },
  {
    id: 3,
    label: (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          height: "100%",
          padding: "0 5px",
        }}
      >
        <span>Return</span>
        <Shortcut keys={["Alt", "4"]} />
      </div>
    ),
    blackIcon: undoBlackIcon,
    whiteIcon: undoWhiteIcon,
  },
  {
    id: 4,
    label: (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          height: "100%",
          padding: "0 5px",
        }}
      >
        <span>Integrations</span>
        <Shortcut keys={["Alt", "5"]} />
      </div>
    ),
    blackIcon: integrationConfigBlack,
    whiteIcon: integrationConfigWhite,
  },
  {
    id: 5,
    label: (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          height: "100%",
          padding: "0 5px",
        }}
      >
        <span>Other Settings</span>
        <Shortcut keys={["Alt", "6"]} />
      </div>
    ),
    blackIcon: settingsBlackIcon,
    whiteIcon: settingsWhiteIcon,
  },
  {
    id: 6,
    label: (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          height: "100%",
          padding: "0 5px",
        }}
      >
        <span>Email</span>
        <Shortcut keys={["Alt", "7"]} />
      </div>
    ),
    blackIcon: emailBlackIcon,
    whiteIcon: emailWhiteIcon,
  },
  // {
  //   id: 6,
  //   label: "Bill Printing",
  //   blackIcon: printerBlackIcon,
  //   whiteIcon: printerWhiteIcon,
  // },
  // { label: "Update", blackIcon: updateBlackIcon, whiteIcon: updateWhiteIcon },
];

export const IS_SELL_IN_LOOSE_OPTIONS = [
  {
    id: "sometimes",
    label: "Sometimes",
  },
  {
    id: "never",
    label: "Never",
  },
  {
    id: "always",
    label: "Always",
  },
];
export const STOP_SALES_FOR_PRODUCTS_OPTIONS = [
  {
    id: "never",
    label: "Never",
  },
  {
    id: "expired",
    label: "Expired",
  },
  {
    id: "near_expiry",
    label: "Near Expiry",
  },
];
export const PRESCRIPTION_OPTIONS = [
  {
    id: "never",
    label: "Never",
  },
  {
    id: "onlyforh1andtb",
    label: "Only for H1 and TB drug sale",
  },
  {
    id: "always",
    label: "Always",
  },
];
